import React, { CSSProperties, useMemo, useRef } from 'react';
import cls from 'classnames';
import { useHover } from 'ahooks';
import jump from '@intelligence/assets/svg/gameInfo/jump.svg';
import jumpHover from '@intelligence/assets/svg/gameInfo/jump-hover.svg';
import download from '@intelligence/assets/svg/gameInfo/download.svg';
import downloadHover from '@intelligence/assets/svg/gameInfo/download-hover.svg';

import './index.scss';

interface IOperationIconProps {
  type: string;
  onClick?: () => void;
  style?: CSSProperties;
  className?: string;
}

interface IIconMap {
  [key: string]: {
    normal: any;
    hover: any;
    style?: CSSProperties;
  };
}

function OperationIcon({ type, onClick, className, style }: IOperationIconProps) {
  const ref = useRef(null);
  const isHovering = useHover(ref);

  const [
    src,
    // imgStyle
  ] = useMemo(() => {
    const iconMap: IIconMap = {
      jump: {
        normal: jump,
        hover: jumpHover,
      },
      download: {
        normal: download,
        hover: downloadHover,
        // 下载图标样式感觉稍长，普通展示对齐有点偏移
        // style: { height: 12 },
      },
    };
    const src = iconMap[type]?.[isHovering ? 'hover' : 'normal'];
    return [src, iconMap[type]?.style];
  }, [type, isHovering]);

  return (
    <div className={cls('dbi-operation-icon', className)} style={style} ref={ref} onClick={onClick}>
      <img
        src={src}
        // style={imgStyle}
      />
    </div>
  );
}

export default OperationIcon;
